import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import Link, { LinkProps } from 'components/commercetools-ui/atoms/link';

export interface LinkButtonProps extends ButtonProps {
  link: LinkProps['link'];
  stopPropagation?: boolean;
  prefetch?: LinkProps['prefetch'];
  /** Anchor `target` — e.g. `"_blank"` to open the link in a new tab. */
  target?: React.HTMLAttributeAnchorTarget;
  /** Anchor `rel` — pair with `target="_blank"` as `"noopener noreferrer"`. */
  rel?: string;
}

export const LinkButton: React.FC<LinkButtonProps> = ({
  link,
  className,
  prefetch = null,
  target,
  rel,
  children,
  ...muiProps
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    muiProps?.onClick?.(event);
  };

  const navProps = {
    component: Link,
    link: link, // Reference link prop for your <Link> component
    prefetch,
    target,
    rel,
  };

  return (
    <Button {...muiProps} {...navProps} className={className} onClick={handleClick}>
      {children}
    </Button>
  );
};
